<template>
  <div id="rg-playback-controller">
    <div class="container">
      <div class="ctl-panel-1">
        <play-button
          class="playback-play-btn-box"
          :playbackStatus="mPlaybackStatus"
          @play="play"
          @pause="pause"
          @rePlay="rePlay"
        ></play-button>
        <playback-speed-button
          class="playback-speed-btn-box"
          @updatePlaybackSpeed="setPlaybackSpeed($event)"
        ></playback-speed-button>
        <div class="ctl-panel-2">
          <playback-progressbar
            class="playback-progressbar-box"
            :dateRange="dateRange"
            :nowTime="nowTime"
            @onChange="onChange($event)"
            @onDragStart="onDragStart"
            @reachEndTime="reachEndTime($event)"
          ></playback-progressbar>
          <div class="row-2-container">
            <playback-time
              class="playback-now-time-box"
              :nowTime="nowTime"
            ></playback-time>
            <layer-filter-buttons
              class="playback-layer-filter-btn-box"
              @updateLayerFilters="setLayerFilters"
              :showPrivatePlot="showPrivatePlot"
            ></layer-filter-buttons>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RadarGridMixin } from "@/mixins";
import "vue-slider-component/theme/antd.css";
import { createNamespacedHelpers, mapGetters } from "vuex";

import PlayButton from "./PlayButton.vue";
import PlaybackSpeedButton from "./PlaybackSpeedButton.vue";
import PlaybackProgressbar from "./PlaybackProgressbar.vue";
import PlaybackTime from "./PlaybackTime.vue";
import LayerFilterButtons from "./LayerFilterButtons.vue";

import C from "../../Constants";

const {
  mapGetters: mapGettersOfRGPlayback,
  mapMutations: mapMutationsOfRGPlayback,
} = createNamespacedHelpers("radarGridPlayback");

export default {
  name: "RgPlaybackController",
  mixins: [RadarGridMixin],
  components: {
    PlayButton,
    PlaybackSpeedButton,
    PlaybackProgressbar,
    PlaybackTime,
    LayerFilterButtons,
  },
  data() {
    return {
      nowTime: 0,
      dateRange: {
        startTime: 0,
        endTime: 0,
      },
      mPlaybackStatus: null,
    };
  },
  watch: {
    playbackSettings(val) {
      this.nowTime = val.now;
      this.dateRange.startTime = val.startTime;
      this.dateRange.endTime = val.endTime;
    },
    playbackTimeNow(val) {
      this.nowTime = val;
    },
    playbackStatus(val) {
      this.mPlaybackStatus = val;
    },
  },
  computed: {
    ...mapGettersOfRGPlayback([
      "playbackSettings",
      "playbackStartTime",
      "playbackTimeNow",
      "playbackStatus",
    ]),
    ...mapGetters({
      getAddonFlag: "getAddonFlag",
    }),
    showPrivatePlot() {
      return this.getAddonFlag("GKMG_PRIVATE_PLOT");
    },
  },
  methods: {
    ...mapMutationsOfRGPlayback([
      "SET_PLAYBACK_TIME_NOW",
      "SET_RG_PLAYBACK_STATUS",
      "SET_RG_PLAYBACK_S",
      "SET_PLAYBACK_SECONDS_PER_FRAME",
      "SET_LAYER_FILTERS",
    ]),
    setPlaybackSpeed(e) {
      this.SET_PLAYBACK_SECONDS_PER_FRAME(e);
    },
    onChange(e) {
      this.SET_RG_PLAYBACK_STATUS(C.PLAYBACK_STATUS.PAUSE);
      this.SET_PLAYBACK_TIME_NOW(e);
    },
    onDragStart() {
      this.SET_RG_PLAYBACK_STATUS(C.PLAYBACK_STATUS.PAUSE);
    },
    reachEndTime(e) {
      this.SET_RG_PLAYBACK_STATUS(C.PLAYBACK_STATUS.REPLAY);
      this.SET_PLAYBACK_TIME_NOW(e);
    },
    play() {
      this.SET_RG_PLAYBACK_STATUS(C.PLAYBACK_STATUS.PLAY);
    },
    pause() {
      this.SET_RG_PLAYBACK_STATUS(C.PLAYBACK_STATUS.PAUSE);
    },
    rePlay() {
      this.SET_PLAYBACK_TIME_NOW(this.playbackStartTime);
      setTimeout(() => {
        this.SET_RG_PLAYBACK_STATUS(C.PLAYBACK_STATUS.PLAY);
      }, 1000);
    },
    setLayerFilters(e) {
      const copyObj = Object.assign({}, e);
      this.SET_LAYER_FILTERS(copyObj);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#rg-playback-controller {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 2;
  width: 60vw;
  height: 60px;

  .container {
    width: 100%;
    height: 100%;
    background-color: rgba(51, 51, 51, 0.7);
    padding: 5px;
    border-radius: 5px;

    .ctl-panel-1 {
      display: flex;
      justify-content: start;

      .playback-play-btn-box {
        flex-basis: 5%;
      }

      .playback-speed-btn-box {
        flex-basis: 5%;
      }

      .ctl-panel-2 {
        flex-basis: 85%;
        display: flex;
        flex-direction: column;

        .playback-progressbar-box {
          padding-left: 24px;
        }

        .row-2-container {
          display: flex;
          padding-left: 24px;

          .playback-now-time-box {
            flex-basis: 50%;
          }

          .playback-layer-filter-btn-box {
            flex-basis: 50%;
          }
        }
      }
    }
  }
}
</style>
